import React from "react";
import { Table, Tag } from "antd";
import { Approval, ApprovalStepStatus } from "../interface";

type Props = {
  approvals?: Approval[];
  title?: string;
};

export const ApprovalDetailsTable: React.FC<Props> = ({
  approvals = [],
  title = "Approval Details"
}) => {
  const sortedApprovals = [...approvals].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const columns = [
    {
      title: "Step",
      dataIndex: "order",
      key: "order",
      width: 80,
    },
    {
      title: "Role",
      dataIndex: "roleSlug",
      key: "roleSlug",
    },
    {
      title: "Step Name",
      dataIndex: "stepName",
      key: "stepName",
    },
    {
      title: "Status",
      dataIndex: "stepStatus",
      key: "stepStatus",
      render: (status: ApprovalStepStatus) => (
        <Tag
          color={
            status === ApprovalStepStatus.APPROVED
              ? "success"
              : status === ApprovalStepStatus.REJECTED
              ? "error"
              : "default"
          }
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      key: "approvedBy",
      render: (approvedBy: string) => approvedBy || "-",
    },
    {
      title: "Approved On",
      dataIndex: "approvedOn",
      key: "approvedOn",
      render: (date: Date | string) => date ? new Date(date).toLocaleDateString() : "-",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (remarks: string) => remarks || "-",
    },
  ];

  return (
    <Table
      title={() => title}
      dataSource={sortedApprovals}
      columns={columns}
      rowKey="order"
      pagination={false}
      size="small"
      bordered
    />
  );
};

export default ApprovalDetailsTable;